export function ValidationDetails({
    entities = [],
    style = {},
    isRelations = false
}) {
    const validatedCount = entities.filter(entity => entity.is_validated).length;
    const unvalidatedCount = entities.length - validatedCount;
    const hasUnvalidatedEntities = unvalidatedCount > 0;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ...style }}>
            {validatedCount > 0 && <span style={{ fontSize: 14 }}>{validatedCount} reviewed</span>}
            {hasUnvalidatedEntities && (
                <span style={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                    <span style={{ marginRight: 4 }}>⚠️</span>
                    <span>{unvalidatedCount} to review </span>
                </span>
            )}
            {validatedCount === 0 && unvalidatedCount === 0 && <span style={{ fontSize: 14 }}>0 {isRelations ? 'relations' : 'entities'}</span>}
        </div>
    );
} 